import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

body {
    background: white;
    margin: 0;
    padding: 0;
    font-family: -apple-system, sans-serif, Roboto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
`;
